import { defineManifest } from "@tc/sdk";
import { CO_TASKS } from "./tasks.js";
export const manifest = defineManifest({
    id: "cash-office",
    name: "Cash Office",
    version: "0.1.0",
    tier: "addon",
    accent: "cash",
    dependsOn: ["sites"],
    description: "Every site's day from the back-office report: takings, cards, fuel and departments read automatically, agreed by the site, corrected and signed off by the cash office, and turned into the operator's invoice when the month or week is complete.",
    permissions: {
        view: "See the cash office days for your sites",
        signoff: "Agree your site's days, raise queries and submit them (operators and site managers)",
        office: "Cash office: load reports, correct lines, answer queries and sign days off",
        settings: "Department mapping and reprocessing (head office)",
        fuel_invoices: "Fuel invoices: match signed-off fuel deliveries to the supplier's invoices (fuel sites only)",
    },
    grants: {
        "Head office": ["view", "office", "settings", "fuel_invoices"],
        "Area manager": ["view"],
        "Site manager": ["view", "signoff"],
    },
    tasks: CO_TASKS,
    widgets: [
        { key: "days", title: "Cash office", description: "Days to sign off, waiting for the cash office, queried and missing, by site.", group: "Cash office", size: 1, permission: "view", defaultOn: true, order: 55 },
        { key: "customer-mix", requires: ["fuel", "wetstock"], title: "Customer mix", description: "Fuel only, shop only, and fuel and shop together: each site's customers from the till's customer profile.", group: "Customers", size: 1, permission: "dashboard.view", defaultOn: true, order: 44 },
    ],
    // The set-up tool's questions (29/10/26): suggested by how sites are run, written into Release & sign-off and each
    // site's sign-off (questions.ts).
    questions: [
        {
            id: "release", ask: "When can a site see its day to agree it?",
            options: [
                { value: "10:00", label: "Next morning at 10:00", help: "The cash office checks it first." },
                { value: "12:00", label: "Next morning at 12:00", help: "The cash office checks it first." },
                { value: "now", label: "Straight away", help: "As soon as the till's report is in." },
            ],
        },
        {
            id: "cadence", ask: "How often do sites agree their days?",
            options: [
                { value: "daily", label: "Every day" },
                { value: "weekly", label: "Once a week", help: "The whole week in one go." },
            ],
        },
    ],
    nav: [
        // The site's daily reconciliation, named as in the old Cloud: CRS on commission sites, SRS (site reconciliation)
        // on company-run and operator-managed sites. Each shows only if you have a site of that kind.
        { label: "CRS", path: "/cash-office/crs", section: "cash", tab: "Sign-off", tabIcon: "check-circle", permission: "signoff", icon: "check", order: 57, when: { operatingModel: ["commission"] }, blurb: "Check and agree each day's figures at a commission site" },
        { label: "SRS", path: "/cash-office/srs", section: "cash", tab: "Sign-off", tabIcon: "check-circle", permission: "signoff", icon: "check", order: 58, when: { operatingModel: ["company", "operator"] }, blurb: "Check and agree each day's figures at your site" },
        { label: "Office sign-off", path: "/cash-office", section: "cash", tab: "Sign-off", tabIcon: "check-circle", permission: "office", icon: "pound", order: 60, blurb: "Load reports, correct lines, answer queries and sign days off" },
        // Fuel review C (Jamie, 23/10/26 14:43): fuel invoices are part of the Cash Office, on the fuel module's data.
        { label: "Fuel invoices", path: "/cash-office/fuel-invoices", section: "cash", tab: "Sign-off", tabIcon: "check-circle", permission: "fuel_invoices", admin: true, icon: "receipt", order: 60.5, requires: ["wetstock"], when: { fuel: true }, blurb: "Signed-off fuel deliveries matched to the supplier's invoices" },
        { label: "CRS configuration", path: "/cash-office/settings", section: "cash", kind: "settings", permission: "settings", icon: "sliders", order: 61, when: { operatingModel: ["commission"] }, blurb: "Department mapping and reprocessing days" },
        // The same page for a company with no commission sites: no "CRS" in its menu (29/10/26). The first that fits shows.
        { label: "Cash office settings", path: "/cash-office/settings", section: "cash", kind: "settings", permission: "settings", icon: "sliders", order: 61, blurb: "Department mapping and reprocessing days" },
    ],
});
